import React from 'react';
import UserDateTimezoneFormat from '../../../../components/user-date-timezone-format';

import { DelegationDateLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const DelegationDate = () => {
  const { delegationDate } = useFulfillmentDisplayContext();

  return (
    <ReadonlyField label={DelegationDateLabel}>
      <UserDateTimezoneFormat dateTime={delegationDate} />
    </ReadonlyField>
  );
};
